import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable, of } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { QeqResponse, QeqUser } from '../../interfaces/qeq.interface';

// Interface for QeQ user data

@Injectable({
  providedIn: 'root',
})
export class QeqService {
  private readonly STORAGE_KEY = 'qeq_data';

  constructor(private apiService: ApiService) {}

  /**
   * Gets QeQ data - first checks localStorage, if not found fetches from API
   */
  getQeQ(): Observable<QeqResponse> {
    const cachedData = this.getQeqFromStorage();

    if (cachedData) {
      return of(cachedData);
    }

    //If the response is:

    /**
     * {
     *   "detail": "No se pudo obtener la lista de usuarios.",
     *   "status_code": 401
     * }
     */
    // logout the user and redirect to login page

    return this.apiService
      .buildAPIGet<QeqResponse>('/users/qeq/')
      .pipe(tap((response) => this.saveQeqToStorage(response)));
  }

  pingQeQ(): Observable<QeqResponse> {
    return this.apiService
      .buildAPIGet<QeqResponse>('/users/qeq/')
      .pipe(tap((response) => this.saveQeqToStorage(response)));
  }

  /**
   * Save QeQ data to localStorage
   */
  private saveQeqToStorage(data: QeqResponse): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      console.error('Error saving QeQ data to localStorage:', error);
    }
  }

  /**
   * Get QeQ data from localStorage
   */
  getQeqFromStorage(): QeqResponse | null {
    try {
      const data = localStorage.getItem(this.STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Error retrieving QeQ data from localStorage:', error);
      return null;
    }
  }

  /**
   * Clear QeQ data from localStorage
   */
  clearQeqCache(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  /**
   * Gets a user by personnel number
   */
  getUserByPersonnelNumber(
    personnelNumber: string
  ): Observable<QeqUser | null> {
    return this.getQeQ().pipe(
      map((response) => {
        const user = response.data.find(
          (user) => user.personnelnumber === personnelNumber
        );
        return user || null;
      })
    );
  }
}
